module.exports = __webpack_public_path__ + "1ecaa01ab7af1a654d183775f7d47be9.svg";